import React, { forwardRef } from 'react';
import { Switch, FormControlLabel } from '@mui/material';

interface CustomSwitchProps {
  id: string;
  label?: string;
  checked?: boolean;
  onChange?: (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => void;
  className?: string;
  color?: 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning';
  size?: 'small' | 'medium';
  disabled?: boolean;
  labelPlacement?: 'end' | 'start' | 'top' | 'bottom';
  required?: boolean;
  disableRipple?: boolean;
}

const CustomSwitch = forwardRef<HTMLButtonElement, CustomSwitchProps>(
  (
    {
      id,
      label,
      checked = false,
      onChange,
      className,
      color = 'primary',
      size = 'medium',
      disabled = false,
      labelPlacement = 'end',
      required = false,
      disableRipple = true,
    },
    ref
  ) => {
    return (
      <FormControlLabel
        control={
          <Switch
            ref={ref}
            id={id}
            checked={checked}
            onChange={onChange}
            className={className}
            color={color}
            size={size}
            disabled={disabled}
            required={required}
            disableRipple={disableRipple}
          />
        }
        label={label}
        labelPlacement={labelPlacement}
      />
    );
  }
);
CustomSwitch.displayName = 'CustomSwitch';
export default CustomSwitch;
